import { composeImgURL } from "../components/homeGridBlock.component"
import { useState, useEffect } from "react"
import { LightBox } from '../pages/collection.page'
import celebritiesJson from "../data/celebrities.json"
import { CollectionItem } from '../pages/home.page'
import Masonry from 'react-masonry-css'

const breakpointColumnsObj = {
    default: 4,
    1100: 3,
    700: 2,
    500: 1
  };
  
export function CelebritiesPage() {
    const [lbImages, setLbImages] = useState<string[]>();
    const [targetIDX, setTargetIDX] = useState<string | null>(null);
    const [celebrities, setCelebrities] = useState<CollectionItem[]>([]); 

    useEffect(() => {
        setCelebrities(celebritiesJson.collectionData);
        let img_urls: string[] = []
        celebritiesJson.collectionData.forEach((cd: CollectionItem) => {
            img_urls.push(...cd.images)
        });
        setLbImages(img_urls);
    }, [targetIDX])

    return (
        <>
        { (lbImages) &&<LightBox urls={lbImages} folder={'../' + celebritiesJson.folder} target={targetIDX} /> }

        <div className="container-fluid g-0">
            <div className="row g-0">
                <div className="col-12 py-3 px-4 bb">
                    <h3>{celebritiesJson.name.toUpperCase()}</h3>
                    <p className="mb-0">{celebritiesJson.description}</p>
                </div>
            </div>
        </div>
        <div className="container mt-5">
            <div className="row">
            <Masonry
                breakpointCols={breakpointColumnsObj}
                className="my-masonry-grid"
                columnClassName="my-masonry-grid_column">
                {
                    celebrities.map((b: CollectionItem, idx) => {
                        return (
                            <div key={idx} className="text-center">
                                <img onClick={(e) => setTargetIDX(b.images[0])} className="img-fluid" src={composeImgURL('../' + celebritiesJson.folder, b.images[0])} />
                                <p>{b.title}</p>
                            </div>
                        )
                    })
                }
            </Masonry>
            </div>
        </div>
        </>
    )
}